import { TableCell, TableRow, useTheme } from '@mui/material';
import React from 'react';
import Coluna from './Coluna';
import { hexWithAlpha } from '../../helper';

type Props = {
  cabecalhoTabela: Coluna<any>[];
  mostrarColunas: boolean[];
  rowObject: any;
  index: number;
  onRowClick?: (obj: any, index: number) => void;
  selected?: boolean;
  colorSelected?: string;
};

const Linha: React.FC<Props> = (props) => {
  const { cabecalhoTabela, mostrarColunas, onRowClick, rowObject, index, selected, colorSelected } =
    props;

  const labelId = `enhanced-table-${index}`;
  let style: React.CSSProperties = { cursor: onRowClick ? 'pointer' : 'default' };

  const theme = useTheme();
  if (selected) {
    style = {
      ...style,
      backgroundColor: colorSelected
        ? colorSelected
        : hexWithAlpha(theme.palette.primary.main, 0.05)
    };
  }

  return (
    <TableRow
      hover
      style={style}
      // onClick={event => onRowClick? onRowClick(rowObject) : {}}
      tabIndex={-1}
      key={index + 'rowObject'}
    >
      {cabecalhoTabela.map(
        (coluna, indexColumn) =>
          mostrarColunas[indexColumn] && (
            <TableCell
              component="th"
              align={coluna.align}
              key={labelId + '-' + indexColumn}
              id={labelId}
              scope="rowObject"
              style={style}
              onClick={(event) => (onRowClick ? onRowClick(rowObject, index) : {})}
            >
              {coluna.render(rowObject, index)}
            </TableCell>
          )
      )}
    </TableRow>
  );
};

export default Linha;
